import brgI18n from '@/locales';
import { workerUseYnType } from '@/constants/worker/workerUseYn';
const i18n = brgI18n.global;
const lc = 'views.worker_management.';
// Worker useYn Type (worker useYn 타입)
// https://qc-zoo-client-api.barogo.io/docs/common/worker-use-yn-type.html
const workerUseYnTypeCode = [
    workerUseYnType.OK,
    workerUseYnType.STOP,
    workerUseYnType.LEAVE,
];
const result = {};
workerUseYnTypeCode.forEach((code, index) => {
    result[code] = {
        text: i18n.t(`${lc}worker_use_yn_type_code_text[${index}]`),
        value: code,
    };
});
export default result;
